/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataPushCompletePayload
 */
export interface DataPushCompletePayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: DataPushCompletePayloadTypeEnum;
    /**
     * 
     */
    captureId: string;
    /**
     * 
     */
    bytesUploaded: number;
    /**
     * 
     */
    durationS: number;
}


/**
 * @export
 */
export const DataPushCompletePayloadTypeEnum = {
    DataPushComplete: 'data_push_complete',
} as const;
export type DataPushCompletePayloadTypeEnum = typeof DataPushCompletePayloadTypeEnum[keyof typeof DataPushCompletePayloadTypeEnum];


/**
 * Check if a given object implements the DataPushCompletePayload interface.
 */
export function instanceOfDataPushCompletePayload(value: object): value is DataPushCompletePayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'data_push_complete') return false;
    
    if ((!('captureId' in (value as Record<string, any>)) && !('capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureId'] === undefined && (value as Record<string, any>)['capture_id'] === undefined)) return false;
    if ((!('bytesUploaded' in (value as Record<string, any>)) && !('bytes_uploaded' in (value as Record<string, any>))) || ((value as Record<string, any>)['bytesUploaded'] === undefined && (value as Record<string, any>)['bytes_uploaded'] === undefined)) return false;
    if ((!('durationS' in (value as Record<string, any>)) && !('duration_s' in (value as Record<string, any>))) || ((value as Record<string, any>)['durationS'] === undefined && (value as Record<string, any>)['duration_s'] === undefined)) return false;
    return true;
}

export function DataPushCompletePayloadFromJSON(json: any): DataPushCompletePayload {
    return DataPushCompletePayloadFromJSONTyped(json, false);
}

export function DataPushCompletePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPushCompletePayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'captureId': json['capture_id'],
        'bytesUploaded': json['bytes_uploaded'],
        'durationS': json['duration_s'],
    };
}

export function DataPushCompletePayloadToJSON(json: any): DataPushCompletePayload {
    return DataPushCompletePayloadToJSONTyped(json, false);
}

export function DataPushCompletePayloadToJSONTyped(value?: DataPushCompletePayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'capture_id': value['captureId'],
        'bytes_uploaded': value['bytesUploaded'],
        'duration_s': value['durationS'],
    };
}

